module.exports = __webpack_public_path__ + "static/img/Paying.9f72c01.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Paying.svg
// module id = Ag4o
// module chunks = 1